module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--wide group--sidebar group--schedule"
  }, [_c('div', {
    staticClass: "group__heading"
  }, [_c('h1', {
    staticClass: "h1 group__title mw600 mb0 m0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Upcoming availability")]), _vm._v(" "), _c('div', {
    staticClass: "query-button"
  }, [_c('p', [_vm._v("Need an alternative date?")]), _vm._v(" "), _c('p', {
    staticClass: "cp fw-bold c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    on: {
      "click": function($event) {
        return _vm.submitAppointmentQuery()
      }
    }
  }, [_vm._v("\n        \n        Submit an appointment request\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "schedule"
  }, [_c('button', {
    class: [
      "schedule__prev",
      (_vm.prevStepDisabled || _vm.forceDisabledPrev) ? "schedule__prev--disabled" : ""
    ],
    attrs: {
      "ontouchstart": "",
      "disabled": _vm.prevStepDisabled || _vm.forceDisabledPrev
    },
    on: {
      "click": function($event) {
        return _vm.loadWeek("prev")
      }
    }
  }), _vm._v(" "), _c('ul', {
    ref: "scheduleWeek",
    class: [
      "schedule__week",
      _vm.allSlotsDisabled ? "schedule__week--no-scroll" : ""
    ]
  }, [_c('transition', {
    attrs: {
      "name": "schedule",
      "mode": "out-in"
    }
  }, [(_vm.loadingAvailabilities || _vm.allSlotsDisabled) ? _c('div', {
    staticClass: "schedule__loader"
  }, [(_vm.loadingAvailabilities) ? _c('module-dots', {
    attrs: {
      "active": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.allSlotsDisabled && !_vm.loadingAvailabilities && !_vm.noAvailableSlots) ? _c('p', {
    staticClass: "h2 tac m0"
  }, [_vm._v("\n\n            There are no sessions available this week. "), _c('br'), _vm._v(" Use "), _c('span', {
    staticClass: "icon icon--next"
  }), _vm._v(" to view future dates.\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.loadingAvailabilities && _vm.noAvailableSlots) ? _c('div', {
    staticClass: "tac"
  }, [_c('h2', {
    staticClass: "mb-"
  }, [_vm._v("No available timeslots")]), _vm._v(" "), _c('p', {
    staticClass: "p mt0"
  }, [_vm._v("Try requesting an appointment with this counselor.")]), _vm._v(" "), _c('module-button', {
    staticClass: "mt-",
    attrs: {
      "button": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitAppointmentQuery()
      }
    }
  }, [_vm._v("\n              Submit an appointment request\n            ")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.availabilities), function(day, index) {
    return _c('li', {
      key: index,
      class: [
        "schedule__day",
        (index === _vm.availabilities.length - 1 ||
          index === _vm.availabilities.length - 2) &&
        !_vm.loadingAvailabilities ?
        ("schedule__day--weekend schedule__day--weekend-" + index) :
        "",
        index === _vm.availabilities.length - 1 ? "schedule__day--last" : ""

      ]
    }, [_c('ul', [_c('li', {
      staticClass: "schedule__heading",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTitle(_vm.availabilityTitles[index]))
      }
    }), _vm._v(" "), _vm._l((_vm.getSlots(day)), function(slot, index) {
      return _c('li', {
        key: index,
        ref: slot,
        refInFor: true,
        class: [
          "schedule__time",
          "fw-medium",
          _vm.allSlotsDisabled || _vm.loadingAvailabilities ?
          "schedule__time--hidden" :
          "",
          slot.disabled ? "schedule__time--disabled" : ""
        ],
        on: {
          "click": function($event) {
            return _vm.selectTimeSlot(slot)
          }
        }
      }, [_c('span', {
        staticClass: "schedule__label",
        style: ({
          'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
        })
      }, [_vm._v(_vm._s(_vm._f("time")(slot.timeslot)))])])
    })], 2)])
  }), _vm._v(" "), _c('button', {
    class: ["schedule__next", "hide-above-medium"],
    attrs: {
      "ontouchstart": "",
      "disabled": _vm.noAvailableSlots
    },
    on: {
      "click": function($event) {
        return _vm.loadWeek("next")
      }
    }
  })], 2), _vm._v(" "), _c('button', {
    class: [
      "schedule__next",
      _vm.allSlotsDisabled && !_vm.loadingAvailabilities ? "" : "hide-below-medium",
      (_vm.noAvailableSlots) ? "schedule__next--disabled" : ""
    ],
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "ontouchstart": "",
      "disabled": _vm.noAvailableSlots
    },
    on: {
      "click": function($event) {
        return _vm.loadWeek("next")
      }
    }
  })]), _vm._v(" "), (!_vm.loadingAvailabilities && _vm.getLongestArrayLength() > 5) ? _c('div', {
    class: [
      "schedule schedule__expand",
      _vm.slotsToShow > 5 ? "schedule__expand--expanded" : ""
    ],
    on: {
      "click": _vm.extendScheduler
    }
  }, [(!_vm.loadingAvailabilities) ? _c('span', {
    staticClass: "expand__label"
  }, [_vm._v(_vm._s(_vm.slotsToShow > 5 ? "Less" : "More") + " times")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loadingAvailabilities || _vm.getLongestArrayLength() <= 5) ? _c('div', {
    staticClass: "schedule schedule__spacer"
  }) : _vm._e(), _vm._v(" "), _c('module-disclaimer', {
    staticClass: "disclaimer--schedule"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "intake",
      "mode": "out-in"
    }
  }, [(_vm.loadingProviderDetails) ? _c('div', {
    staticClass: "bbg bbg--white group group--wide provider-detail__loader"
  }, [_c('module-dots', {
    attrs: {
      "active": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingProviderDetails) ? _c('article', {
    staticClass: "bbg bbg--white group group--wide"
  }, [(_vm.overview) ? _c('section', {
    staticClass: "section section--approach ovh"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Overview")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.overview))])]) : _vm._e(), _vm._v(" "), (_vm.specialties) ? _c('section', {
    staticClass: "section section--approach ovh"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Specialities")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.specialties))])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "section section--things-to-know"
  }, [_c('div', {
    staticClass: "section__group"
  }, [(_vm.languages) ? _c('div', {
    staticClass: "section__group-item"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Languages")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.languages))])]) : _vm._e(), _vm._v(" "), (_vm.experience) ? _c('div', {
    staticClass: "section__group-item"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Experience")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.experience) + " years")])]) : _vm._e(), _vm._v(" "), (_vm.location) ? _c('div', {
    staticClass: "section__group-item"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Location")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.location))])]) : _vm._e()])]), _vm._v(" "), (_vm.education) ? _c('section', {
    staticClass: "section section--approach ovh"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Education")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.education))])]) : _vm._e(), _vm._v(" "), (_vm.licensedStates) ? _c('section', {
    staticClass: "section section--approach ovh pab2"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Licensed States")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.licensedStates))])]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14bf8392"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/provider/Schedule.vue
// module id = 504
// module chunks = 0